<template>
  <div
    class="position-relative justify-content-center d-flex"
    @mouseover="onMouseOver()"
    @mouseleave="onMouseLeave()"
  >
    <button
      @click.prevent="clicked()"
      :disabled="loading"
      class="btn w-100 rounded-5"
      :class="[{ 'my-3': marginVertical }, btnColor]"
    >
      <span
        v-if="loading"
        class="spinner-border spinner-border-sm me-2"
        role="status"
        aria-hidden="true"
      ></span>
      <span class="text-action">
        {{ label }}
      </span>
    </button>
    <div
      v-if="showError && fieldError"
      class="position-absolute shadow-lg bg-danger-soft rounded text-center"
      style="top: -50px; z-index: 10"
    >
      <p class="popover-header text-danger p-3 mb-0 fw-bold">
        <i class="fa-solid fa-exclamation-circle"></i>
        {{ fieldError }}
      </p>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from "vue";

const props = withDefaults(
  defineProps<{
    disabled?: boolean;
    marginVertical?: boolean;
    loading?: boolean;
    label?: string;
    form?: any;
    outline?: boolean;
    color?: string;
    outlineColor?: string;
  }>(),
  {
    disabled: false,
    marginVertical: true,
    loading: false,
    label: "Field name",
    form: null,
    outline: false,
    color: "secondary",
    outlineColor: "primary",
  },
);

const emit = defineEmits<{
  onClick: [];
}>();

const showError = ref(false);

const fieldError = computed(() => {
  if (!props.form) return;
  let msg = "";
  try {
    const messages = props.form.$silentErrors?.map((r: any) => r.$message);
    msg = messages.length ? messages[0] : "";
  } catch (e) {
    console.log(e);
    msg = "";
  } finally {
    return msg;
  }
});

const btnColor = computed(() =>
  props.outline ? `btn-outline-${props.outlineColor}` : `btn-${props.color}`,
);

const clicked = () => {
  if (props.disabled) return;
  emit("onClick");
};

const onMouseOver = () => {
  showError.value = true;
};

const onMouseLeave = () => {
  showError.value = false;
};
</script>
